"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SaveEmailRequest = void 0;
var SaveEmailRequest = /** @class */ (function () {
    function SaveEmailRequest() {
    }
    return SaveEmailRequest;
}());
exports.SaveEmailRequest = SaveEmailRequest;
;
//# sourceMappingURL=saveEmail.request.js.map